if (!customElements.get('product-sticky')) {
  customElements.define(
    'product-sticky',
    class ProductSticky extends HTMLElement {
      constructor() {
        super();
        this.anchor = this.getAnchor();
        this.onScrollHandler = this.onScroll.bind(this);
        this.resizeObserver = new ResizeObserver(() => this.updateStickyHeight());
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        this.resizeObserver.disconnect();
      }

      getAnchor() {
        const mainProduct = this.closest('[id^=MainProduct-]');
        return mainProduct?.querySelector('[id^=ProductSubmitButton-]') || mainProduct;
      }

      onScroll() {
        if (!this.anchor) return;

        this.classList.remove('hidden');
        this.check(this.anchor, 100) ? this.show() : this.hide();
      }

      check(element, threshold = 0) {
        return element.getBoundingClientRect().y + threshold < 0;
      }

      show() {
        this.classList.add('animate', 'active');
        document.body.classList.add('product-sticky__show');
        this.updateStickyHeight();
      }

      hide() {
        this.classList.remove('animate', 'active');
        document.body.classList.remove('product-sticky__show');
        this.updateStickyHeight(0);
      }

      updateStickyHeight(height = this.offsetHeight) {
        document.body.style.setProperty('--product-sticky-height', `${Math.floor(height)}px`);
      }
    }
  );
}
